export const GAME_LANUGAME = {
  263: {
    default: 'en-US',
    'vi-VN': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'en-US': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'ja-JP': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'ko-KR': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'th-TH': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'ru-RU': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'zh-TW': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'zh-CN': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'de-DE': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'fr-FR': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'pt-PT': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'tr-TR': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'es-ES': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'it-IT': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'pl-PL': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'id-ID': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    },
    'ar-SA': {
      activityEntryTimeLimit: 'Claim Your Reward！',
    }
  },
  285: {
    default: 'en-US',
    'vi-VN': {
      activityEntryTimeLimit: 'Phúc Lợi Hạn Giờ',
    },
    'en-US': {
      activityEntryTimeLimit: 'Exclusive Limited-Time Offer',
    },
    'ja-JP': {
      activityEntryTimeLimit: '期間限定特典',
    },
    'ko-KR': {
      activityEntryTimeLimit: '한정 혜택',
    },
    'th-TH': {
      activityEntryTimeLimit: 'สมนาคุณสุดพิเศษ',
    },
    'ru-RU': {
      activityEntryTimeLimit: 'Особое временное предложение',
    },
    'zh-TW': {
      activityEntryTimeLimit: '限時福利',
    },
    'zh-CN': {
      activityEntryTimeLimit: '限时福利',
    },
    'de-DE': {
      activityEntryTimeLimit: 'Exklusives, zeitlich begrenztes Angebot',
    },
    'fr-FR': {
      activityEntryTimeLimit: 'Offre exclusive en temps limité',
    },
    'pt-PT': {
      activityEntryTimeLimit: 'Oferta exclusiva por tempo limitado',
    },
    'tr-TR': {
      activityEntryTimeLimit: 'Sınırlı Süreli Özel Teklif',
    },
    'es-ES': {
      activityEntryTimeLimit: 'Oferta exclusiva por tiempo limitado',
    },
    'it-IT': {
      activityEntryTimeLimit: 'Offerta Esclusiva a Tempo Limitato',
    },
    'pl-PL': {
      activityEntryTimeLimit: 'Ekskluzywna oferta ograniczona czasowo',
    },
    'id-ID': {
      activityEntryTimeLimit: 'Benefit Waktu Terbatas',
    },
    'ar-SA': {
      activityEntryTimeLimit: 'فوائد لفترة محدودة',
    }
  },
  215: {
    default: 'vi-VN',
    'vi-VN': {
      currencyTips:
        '1.Trị giá Thông Bảo: 1 Thông Bảo≈3000VND.</br>2.Thông bảo chưởng quỹ sẽ được gửi vào hòm thư của bạn, thánh toán gói hoặc nguyên bảo bằng Thông Bảo sẽ nhận được EXP VIP.',
      currencyType: 'Thông Bảo',
      coinType: 'Nguyên Bảo',
      maxExtraRatio: 'Nguyên Bảo Tăng $rate'
    },
    'en-US': {
      currencyType: 'Trader Token',
      coinType: 'Ingots',
      maxExtraRatio: 'Up to $rate Extra Ingots'
    },
    'ja-JP': {
      currencyType: '商人通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝　最大$rate増量'
    },
    'ko-KR': {
      currencyType: '사장 통보',
      coinType: '원보',
      maxExtraRatio: '원보 최대 $rate 추가'
    },
    'th-TH': {
      currencyType: 'เหรียญเถ้าแก่',
      coinType: 'ก้อนทอง',
      maxExtraRatio: 'โบนัสก้อนทองสูงสุด $rate'
    },
    'ru-RU': {
      currencyType: 'жетон торговца',
      coinType: 'Слиток'
    },
    'zh-TW': {
      currencyType: '掌櫃通寶',
      coinType: '元寶',
      maxExtraRatio: '元寶最高加碼$rate'
    },
    'zh-CN': {
      currencyType: '掌柜通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝最高加码$rate'
    }
  },
  211: {
    default: 'ko-KR',
    'ko-KR': {
      currencyTips:
        '1. 사장 통보 가격: 180원≈1사장 통보.</br>2. 구입한 사장 통보는 우편으로 발송되며, 게임 내에서 임의의 패키지, 원보를 구입하는 데 사용됩니다. 사장 통보를 소모하면 해당 금액만큼 VIP 경험치를 획득합니다.',
      currencyType: '사장 통보',
      coinType: '원보',
      maxExtraRatio: '원보 최대 $rate 추가'
    },
    'en-US': {
      currencyType: 'Trader Token',
      coinType: 'Ingots',
      maxExtraRatio: 'Up to $rate Extra Ingots'
    },
    'ja-JP': {
      currencyType: '商人通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝　最大$rate増量'
    },
    'th-TH': {
      currencyType: 'เหรียญเถ้าแก่',
      coinType: 'ก้อนทอง',
      maxExtraRatio: 'โบนัสก้อนทองสูงสุด $rate'
    },
    'ru-RU': {
      currencyType: 'жетон торговца',
      coinType: 'Слиток'
    },
    'zh-TW': {
      currencyType: '掌櫃通寶',
      coinType: '元寶',
      maxExtraRatio: '元寶最高加碼$rate'
    },
    'zh-CN': {
      currencyType: '掌柜通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝最高加码$rate'
    }
  },
  213: {
    default: 'en-US',
    'en-US': {
      currencyTips:
        "1. Worth of Trader Token: 0.14USD ≈ 1 Trader Token.</br>2. The Trader Tokens you've purchased will be sent via mail. It can be used to buy any packs and ingots in the game, granting you VIP EXP equal to the purchase amount.",
      currencyType: 'Trader Token',
      coinType: 'Ingots',
      maxExtraRatio: 'Up to $rate Extra Ingots'
    },
    'ko-KR': {
      currencyType: '사장 통보',
      coinType: '원보',
      maxExtraRatio: '원보 최대 $rate 추가'
    },
    'ja-JP': {
      currencyType: '商人通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝　最大$rate増量'
    },
    'th-TH': {
      currencyTips:
        '1.มูลค่าเหรียญเถ้าแก่ : 0.14USD≈1 เหรียญเถ้าแก่</br>2.หลังซื้อเหรียญเถ้าแก่ ระบบจะส่งให้ทางอีเมล สามารถใช้ซื้อแพ็กและก้อนทองได้ และเมื่อใช้เหรียญเถ้าแก่ ก็จะได้รับ EXP VIP เช่นกัน',
      currencyType: 'เหรียญเถ้าแก่',
      coinType: 'ก้อนทอง',
      maxExtraRatio: 'โบนัสก้อนทองสูงสุด $rate'
    },
    'ru-RU': {
      currencyTips:
        '1. Стоимость жетона торговца: 1 жетон торговца ≈ 0.14 USD</br>2. Купленные жетоны торговца будут отправлены на почту. Их можно будет использовать для покупки любых наборов и слитков, при этом вы будете получать эквивалентный покупке опыт VIP.',
      currencyType: 'жетон торговца',
      coinType: 'Слиток'
    },
    'zh-TW': {
      currencyType: '掌櫃通寶',
      coinType: '元寶',
      maxExtraRatio: '元寶最高加碼$rate'
    },
    'zh-CN': {
      currencyType: '掌柜通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝最高加码$rate'
    }
  },
  209: {
    default: 'ja-JP',
    'ja-JP': {
      currencyTips:
        '1．商人通宝の価値：18円≈1商人通宝。</br>2．購入した商人通宝は手紙で送信されます。商人通宝を使用すると、ゲーム内で任意パック、元宝を購入できます。商人通宝を使用すると対応する値のVIP経験を獲得できます。',
      currencyType: '商人通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝　最大$rate増量'
    },
    'ko-KR': {
      currencyType: '사장 통보',
      coinType: '원보',
      maxExtraRatio: '원보 최대 $rate 추가'
    },
    'en-US': {
      currencyType: 'Trader Token',
      coinType: 'Ingots',
      maxExtraRatio: 'Up to $rate Extra Ingots'
    },
    'th-TH': {
      currencyType: 'เหรียญเถ้าแก่',
      coinType: 'ก้อนทอง',
      maxExtraRatio: 'โบนัสก้อนทองสูงสุด $rate'
    },
    'ru-RU': {
      currencyType: 'жетон торговца',
      coinType: 'Слиток'
    },
    'zh-TW': {
      currencyType: '掌櫃通寶',
      coinType: '元寶',
      maxExtraRatio: '元寶最高加碼$rate'
    },
    'zh-CN': {
      currencyType: '掌柜通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝最高加码$rate'
    }
  },
  191: {
    default: 'en-US',
    'vi-VN': {
      activityEntryTimeLimit: 'Phúc Lợi Hạn Giờ',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'Công Viên Kinh Dị',
      maxExtraRatio: 'Cộng Kim Cương $rate'
    },
    'en-US': {
      activityEntryTimeLimit: 'Exclusive Limited-Time Offer',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'The Park of Puppets',
      maxExtraRatio: 'Bonus: $rate Diamonds'
    },
    'ja-JP': {
      activityEntryTimeLimit: '期間限定特典',
      activityEntryWarOrder: '世紀末の生存指南',
      activityEntry: '恐怖の遊園地',
      maxExtraRatio: 'ダイヤ+$rate'
    },
    'ko-KR': {
      activityEntryTimeLimit: '한정 혜택',
      activityEntryWarOrder: '종말 생존수첩',
      activityEntry: '공포의 놀이공원',
      maxExtraRatio: '보너스: $rate 다이아'
    },
    'th-TH': {
      activityEntryTimeLimit: 'สมนาคุณสุดพิเศษ',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'สวนสนุกน่ากลัว',
      maxExtraRatio: 'โบนัสเพชร $rate'
    },
    'ru-RU': {
      activityEntryTimeLimit: 'Особое временное предложение',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'Кукольный парк',
      maxExtraRatio: 'Бонус: $rate Алмазов'
    },
    'zh-TW': {
      activityEntryTimeLimit: '限時福利',
      activityEntryWarOrder: '末世生存手冊',
      activityEntry: '恐怖遊樂園',
      maxExtraRatio: '鑽石加碼$rate'
    },
    'zh-CN': {
      activityEntryTimeLimit: '限时福利',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: '恐怖游乐园',
      maxExtraRatio: '钻石加码$rate'
    },
    'de-DE': {
      activityEntryTimeLimit: 'Exklusives, zeitlich begrenztes Angebot',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'Park der Puppen',
      maxExtraRatio: 'Bonus: $rate Diamanten'
    },
    'fr-FR': {
      activityEntryTimeLimit: 'Offre exclusive en temps limité',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'Parc des Marionnettes',
      maxExtraRatio: 'Bonus : $rate Diamants'
    },
    'pt-PT': {
      activityEntryTimeLimit: 'Oferta exclusiva por tempo limitado',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'O Parque das Marionetes',
      maxExtraRatio: 'Bônus: $rate Diamantes'
    },
    'tr-TR': {
      activityEntryTimeLimit: 'Sınırlı Süreli Özel Teklif',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'Kukla Parkı',
      maxExtraRatio: 'Bonus: $rate Elmas'
    },
    'es-ES': {
      activityEntryTimeLimit: 'Oferta exclusiva por tiempo limitado',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'Parque de las marionetas',
      maxExtraRatio: 'Bonificación: $rate diamantes'
    },
    'it-IT': {
      activityEntryTimeLimit: 'Offerta Esclusiva a Tempo Limitato',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'Il Parco delle Marionette',
      maxExtraRatio: 'Bonus: $rate Diamanti'
    },
    'pl-PL': {
      activityEntryTimeLimit: 'Ekskluzywna oferta ograniczona czasowo',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'Park Marionetek',
      maxExtraRatio: 'Bonus: $rate Diamentów'
    },
    'id-ID': {
      activityEntryTimeLimit: 'Benefit Waktu Terbatas',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'Horor Park',
      maxExtraRatio: 'Diamond bonus $rate'
    },
    'ar-SA': {
      activityEntryTimeLimit: 'فوائد لفترة محدودة',
      activityEntryWarOrder: 'Survival Manual',
      activityEntry: 'حديقة الرعب',
      maxExtraRatio: 'كلمة السر االماسية$rate'
    }
  }
};

export const getGameLanguage = (lang, key, game) => {
  if (
    !GAME_LANUGAME[game] ||
    !GAME_LANUGAME[game].default ||
    !GAME_LANUGAME[game][GAME_LANUGAME[game].default][key]
  ) {
    return '';
  }

  let realLang =
    GAME_LANUGAME[game][lang] && GAME_LANUGAME[game][lang][key]
      ? lang
      : GAME_LANUGAME[game].default;
  return GAME_LANUGAME[game][realLang][key];
};
